export const TAB_TYPES = {
  LIST: 'list',
  COLLECTION: 'collection'
};

export const TAB_LIST = [
  TAB_TYPES.LIST,
  TAB_TYPES.COLLECTION
];

export const TAB_TITLES = {
  [TAB_TYPES.LIST]: '最新上線',
  [TAB_TYPES.COLLECTION]: '我的收藏'
};

export default {
  tabTypeList: TAB_TYPES,
  tabList: TAB_LIST,
  tabTitleList: TAB_TITLES,
  columnHeader: [
    {
      id: 'isCollected',
      textLabel: '收藏',
      type: 'slot',
      width: '50px',
    },
    {
      id: 'name',
      textLabel: '名稱',
      type: 'text-chip',
    },
    {
      id: 'announceAt',
      textLabel: '修正發布日',
      type: 'text',
      width: '105px',
      noWrap: true,
    },
    {
      id: 'guidelineStatus',
      textLabel: '施行狀態',
      type: 'badge',
      width: '50px',
      isI18n: false,
    },
  ],
  filterFieldTypeList: [
    {
      name: 'search',
      type: 'search',
      title: '名稱',
    },
    {
      name: 'duration',
      type: 'date-duration',
      title: '修正發布日',
      defaultValue: {
        start: '',
        end: '',
      }
    },
    {
      name: 'guidelineStatus',
      type: 'one-layer-dropdown',
    },
    {
      name: 'factoryTags',
      type: 'one-layer-dropdown',
    },
  ],
};